import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  position: block;
  z-index: 10;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 45%;

    &.digital-product {
      position: absolute;
    }

    &.product-device-step {
      margin: auto;
    }
  }
`;

export const StepControls = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${themeGet('colors.light-border-grey')};
  display: inline-flex;
  border: none;
  border-radius: 20px;
  box-shadow: 0 2px 4px 0 rgba(190, 190, 190, 0.3);
  background-color: ${themeGet('colors.white')};
  margin: auto;
  min-height: 35px;
  min-width: 168px;
  ${Wrapper}.product-device-step & {
    min-width: 178px;
  }
`;

export const StepButton = styled.button`
  color: ${themeGet('colors.main-text')};
  &.active {
    color: ${themeGet('colors.pc-red')};
  }
  flex: 1 1 100%;
  position: relative;
  height: 43px;
  font-size: 14px;
  transition: color 300ms ease;
  font-size: 14px;
  font-weight: ${themeGet('fontWeights.medium')};
  height: auto;
  ${Wrapper}.product-device-step & {
    left: -4px;
  }

  :hover,
  :focus {
    color: ${themeGet('colors.pc-red', '#E1251B')};
  }
`;
